/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-06-16 15:46:40
 * @LastEditors: Qiaofan
 * @LastEditTime: 2023-08-11 09:53:03
 * @FilePath: \low_code_designer\common\models\TokenParseModel\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { toast } from './toast/index';
import { getMultiLang } from './getMultiLang';

// 替换 lodash 包中的get方法，减小打包体积
function get(source, paths, defaultValue = undefined) {
    let result = source;
    for (const p of paths) {
        result = Object(result)[p];
        if (result === undefined) {
            return defaultValue;
        }
    }
    return result;
}

const TokenType = {

    /**
     * 表达式中词的类型
     * @type {String}
     */
    // OR,AND逻辑预算符，只支持布尔值或表达式进行逻辑运算
    OR: 'or',
    AND: 'and',
    // 关系运算符，只支持数值比较大小
    GT: '>',
    GE: '≥',
    LT: '<',
    LE: '≤',
    // 支持数值、字符串、布尔值进行比较是否相等
    EQUAL: '=',
    NOTEQUAL: '≠',
    INCLUDE: '⊂', // 包含
    EXCLUDE: '⊄', // 不包含
    LEFT_INCLUDE: '⊇', // 左包含
    RIGHT_INCLUDE: '⊆', // 右包含
    EMPTY: '{}',
    NOT_EMPTY: '{Ø}',
    // 加减乘除数值运算符，只支持数值进行运算
    PLUS: '+',
    MINUS: '-',
    MULTIPLY: '*',
    DIVIDE: '/',
    // 指标，相当于字面量，index中的值可以是数值类型或字符串类型，字符串类型必须使用''引起来
    INDEX: 'index',
    // 相当于变量
    FIELD: 'field',
    // 左右括号
    LEFT_PARENTHESIS: '(',
    RIGHT_PARENTHESIS: ')',
};

const ASTNodeType = {

    /**
     * 抽象语法树节点，代表表达式值的类型
     * @type {String}
     */
    // 数值类型
    NUMERIC: 'numeric',
    // 布尔类型
    LOGICAL: 'logical',
    // 字符串类型
    STRING: 'string',
};

const DefaultOperators = {
    [TokenType.OR]: (lh, rh) => lh || rh,
    [TokenType.AND]: (lh, rh) => lh && rh,

    [TokenType.GT]: (lh, rh) => lh > rh,
    [TokenType.GE]: (lh, rh) => lh >= rh,
    [TokenType.LT]: (lh, rh) => lh < rh,
    [TokenType.LE]: (lh, rh) => lh <= rh,
    [TokenType.EQUAL]: (lh, rh) => lh === rh,
    [TokenType.NOTEQUAL]: (lh, rh) => lh !== rh,

    [TokenType.INCLUDE]: (lh, rh) => typeof (lh) === 'string' && typeof (rh) === 'string' && lh.indexOf(rh) > -1,
    [TokenType.EXCLUDE]: (lh, rh) => typeof (lh) === 'string' && typeof (rh) === 'string' && lh.indexOf(rh) === -1,
    [TokenType.LEFT_INCLUDE]: (lh, rh) => typeof (lh) === 'string' && typeof (rh) === 'string' && lh.slice(0, rh.length) === rh,
    [TokenType.RIGHT_INCLUDE]: (lh, rh) => typeof (lh) === 'string' && typeof (rh) === 'string' && lh.slice(-rh.length) === rh,

    [TokenType.EMPTY]: (lh, rh) => lh === rh,
    [TokenType.NOT_EMPTY]: (lh, rh) => lh !== rh,

    [TokenType.PLUS]: (lh, rh) => lh + rh,
    [TokenType.MINUS]: (lh, rh) => lh - rh,
    [TokenType.MULTIPLY]: (lh, rh) => lh * rh,
    [TokenType.DIVIDE]: (lh, rh) => lh / rh,

    [TokenType.INDEX]: (nodeMeta, dataSet) => nodeMeta.text,
    [TokenType.FIELD]: (nodeMeta, dataSet) => {
        let { areaCode, itemCode } = nodeMeta;
        return get(dataSet, [`${areaCode}`, `${itemCode}`]);
    },
};

class TokenParseModel {
    constructor(tokensData) {
        this.cursor = 0;
        this.hasLeftBrackets = 0;
        this.arrToken = tokensData;
        this.nodeTree = null;
        this.tokensValid = true;
    }

    initNodeTreeData() {
        if (this.arrToken.length > 0) {
            this.nodeTree = this.orExpr();
        }
    }

    getCursor() {
        return this.cursor;
    }

    /**
    * 预读下一个token,cursor不变
    */
    peek() {
        return this.arrToken[this.cursor] === undefined ? null : this.arrToken[this.cursor];
    }

    /**
    * 读取下一个token，cursor + 1
    */
    read() {
        return this.arrToken[this.cursor] === undefined ? null : this.arrToken[this.cursor++];
    }

    checkNodeType(child1, child2, op, type) {
        if (child1 === null || child2 === null) {
            this.tokensValid = false;
            let getJsonCallback = json => {
                toast({
                    color: 'danger',
                    title: json["api-token-parse-0001"],
                    content: json["api-token-parse-0002"],
                });
            };
            getMultiLang({ moduleId: "api_token_parse_model", callback: getJsonCallback });
            return;
        }
        if (child1.type !== type) {
            this.tokensValid = false;
            let getJsonCallback = json => {
                toast({
                    color: 'danger',
                    title: json["api-token-parse-0001"],
                    content: json["api-token-parse-0002"],
                });
            };
            getMultiLang({ moduleId: "api_token_parse_model", callback: getJsonCallback });
            return;
        }
        if (child2.type !== type) {
            this.tokensValid = false;
            let getJsonCallback = json => {
                toast({
                    color: 'danger',
                    title: json["api-token-parse-0001"],
                    content: json["api-token-parse-0002"],
                });
            };
            getMultiLang({ moduleId: "api_token_parse_model", callback: getJsonCallback });
            return false;
        }
    }

    /**
         * 解析or表达式
         * or表达式CFG如下: orExpr -> andExpr ( or andExpr )*
         * 表示or运算符表达式由1个或者多个and表达式组成，多个and表达式之间由or运算符连接
         *
    */
    orExpr() {
        let child1 = this.andExpr();
        let node = child1;
        if (child1 !== null) {
            let token = this.peek();
            if (token !== null && token.type !== TokenType.OR && token.type !== TokenType.RIGHT_PARENTHESIS) {
                this.tokensValid = false;
                let getJsonCallback = json => {
                    toast({
                        color: 'danger',
                        title: json["api-token-parse-0001"],
                        content: json["api-token-parse-0002"],
                    });
                };
                getMultiLang({ moduleId: "api_token_parse_model", callback: getJsonCallback });
                return false;
            }
            while (token !== null && token.type === TokenType.OR) {
                // 读出or运算符
                token = this.read();
                // 计算下级节点
                let child2 = this.andExpr();
                this.checkNodeType(child1, child2, token.text, ASTNodeType.LOGICAL);
                node = {
                    type: ASTNodeType.LOGICAL,
                    tokenType: token.type,
                    text: token.tokenValue,
                    areaCode: token.areaCode,
                    itemCode: token.itemCode,
                    itemType: token.itemType,
                    children: [],
                };
                node.children.push(child1);
                node.children.push(child2);
                child1 = node;
                token = this.peek();
            }
        }
        return node;
    }

    /**
    * 解析and表达式
    * and表达式的CFG如下: andExpr -> relExpr (and relExpr)*
    * 表示and运算符表达式由1个或者多个关系表达式组成，多个关系表达式之间由and运算符连接
    */
    andExpr() {
        let child1 = this.relExpr();
        let node = child1;
        if (child1 !== null) {
            let token = this.peek();
            while (token !== null && token.type === TokenType.AND) {
                // 读出and运算符
                token = this.read();
                // 计算下级节点
                let child2 = this.relExpr();
                this.checkNodeType(child1, child2, token.text, ASTNodeType.LOGICAL);
                node = {
                    type: ASTNodeType.LOGICAL,
                    tokenType: token.type,
                    text: token.tokenValue,
                    areaCode: token.areaCode,
                    itemCode: token.itemCode,
                    itemType: token.itemType,
                    children: [],
                };
                node.children.push(child1);
                node.children.push(child2);
                child1 = node;
                token = this.peek();
            }
        }
        return node;
    }

    /**
         * 解析关系表达式
         * 关系表达式的CFG如下：relExpr -> addExpr ( > addExpr )* | addExpr ( >= addExpr )* |
         *                   addExpr ( < addExpr )* | addExpr ( <= addExpr )* |
         *                   addExpr ( = addExpr )*
         * 表示关系比较运算符表达式由1个或者多个加减运算表达式组成，多个加减表达式之间由关系比较运算符连接
         */
    relExpr() {
        let child1 = this.addExpr();
        let node = child1;
        if (child1 !== null) {
            let token = this.peek();
            while (token !== null && (token.type === TokenType.GT ||
                token.type === TokenType.GE ||
                token.type === TokenType.LT ||
                token.type === TokenType.LE ||
                token.type === TokenType.EQUAL ||
                token.type === TokenType.NOTEQUAL ||
                token.type === TokenType.INCLUDE ||
                token.type === TokenType.EXCLUDE ||
                token.type === TokenType.LEFT_INCLUDE ||
                token.type === TokenType.RIGHT_INCLUDE ||
                token.type === TokenType.EMPTY ||
                token.type === TokenType.NOT_EMPTY
            )) {
                // 读取关系运算符
                token = this.read();
                // 计算下级节点
                let child2 = this.addExpr();
                if (token.type !== TokenType.EQUAL) {
                    this.checkNodeType(child1, child2, token.text, ASTNodeType.NUMERIC);
                }
                node = {
                    type: ASTNodeType.LOGICAL,
                    tokenType: token.type,
                    text: token.tokenValue,
                    areaCode: token.areaCode,
                    itemCode: token.itemCode,
                    itemType: token.itemType,
                    children: [],
                };
                node.children.push(child1);
                node.children.push(child2);
                child1 = node;
                token = this.peek();
            }
        }
        return node;
    }

    /**
         * 解析加减运算表达式
         * 加减运算表达式CFG如下： addExpr -> mulExpr ( + mulExpr )* | mulExpr (- mulExpr)*
         * 表示加减运算表达式由1个或者多个乘除运算表达式组成，多个乘除运算表达式之间由加减运算符连接
         */
    addExpr() {
        let child1 = this.mulExpr();
        let node = child1;
        if (child1 !== null) {
            let token = this.peek();
            while (token !== null && (
                token.type === TokenType.PLUS || token.type === TokenType.MINUS
            )) {
                // 读取加减运算符
                token = this.read();
                // 计算下级节点
                let child2 = this.mulExpr();
                this.checkNodeType(child1, child2, token.text, ASTNodeType.NUMERIC);
                node = {
                    type: ASTNodeType.NUMERIC,
                    tokenType: token.type,
                    text: token.tokenValue,
                    areaCode: token.areaCode,
                    itemCode: token.itemCode,
                    itemType: token.itemType,
                    children: [],
                };
                node.children.push(child1);
                node.children.push(child2);
                child1 = node;
                token = this.peek();
            }
        }
        return node;
    }

    /**
         * 解析乘除运算表达式
         * 乘除运算表达式CFG如下: mulExpr -> priExpr (* priExpr)* | priExpr (/ priExpr)*
         * 表示乘除运算表达式由1个或者多个字面量表达式组成，多个字面量表达式之间由乘除运算符连接
         */
    mulExpr() {
        let child1 = this.priExpr();
        let node = child1;
        if (child1 !== null) {
            let token = this.peek();
            while (token !== null && (
                (token.type === TokenType.MULTIPLY || token.type === TokenType.DIVIDE) ||
                (this.hasLeftBrackets === 0 && token.type === TokenType.RIGHT_PARENTHESIS)
            )) {
                if (token.type === TokenType.MULTIPLY || token.type === TokenType.DIVIDE) {
                    token = this.read();
                    let child2 = this.priExpr();
                    this.checkNodeType(child1, child2, token.text, ASTNodeType.NUMERIC);
                    node = {
                        type: ASTNodeType.NUMERIC,
                        tokenType: token.type,
                        text: token.tokenValue,
                        areaCode: token.areaCode,
                        itemCode: token.itemCode,
                        itemType: token.itemType,
                        children: [],
                    };
                    node.children.push(child1);
                    node.children.push(child2);
                    child1 = node;
                    token = this.peek();
                } else if (this.hasLeftBrackets === 0 && token.type === TokenType.RIGHT_PARENTHESIS) {
                    this.tokensValid = false;
                    let getJsonCallback = json => {
                        toast({
                            color: 'danger',
                            title: json["api-token-parse-0001"],
                            content: json["api-token-parse-0002"],
                        });
                    };
                    getMultiLang({ moduleId: "api_token_parse_model", callback: getJsonCallback });
                    return node;
                }
            }
        }

        return node;
    }

    /**
         * 解析字面量表达式
         */
    priExpr() {
        let token = this.peek();
        let node = null;
        if (token !== null && token.type === TokenType.LEFT_PARENTHESIS) {
            token = this.read();
            this.hasLeftBrackets++;
            node = this.orExpr();
            token = this.read();
            this.hasLeftBrackets--;
            if (token === null) {
                try {
                    this.tokensValid = false;
                    let getJsonCallback = json => {
                        toast({
                            color: 'danger',
                            title: json["api-token-parse-0001"],
                            content: json["api-token-parse-0002"],
                        });
                    };
                    getMultiLang({ moduleId: "api_token_parse_model", callback: getJsonCallback });
                    return node;
                } catch (e) {
                    console.log(e);
                }

            }
            if (token !== null && token.type !== TokenType.RIGHT_PARENTHESIS) {
                this.tokensValid = false;
                let getJsonCallback = json => {
                    toast({
                        color: 'danger',
                        title: json["api-token-parse-0001"],
                        content: json["api-token-parse-0002"],
                    });
                };
                getMultiLang({ moduleId: "api_token_parse_model", callback: getJsonCallback });
                return node;
            }
        } else if (token !== null && (token.type === TokenType.INDEX || token.type === TokenType.FIELD)) {
            token = this.read();
            node = {
                type: ASTNodeType.NUMERIC,
                tokenType: token.type,
                text: token.tokenValue,
                areaCode: token.areaCode,
                itemCode: token.itemCode,
                itemType: token.itemType,
                children: [],
            };
        } else if (token !== null && token.type === TokenType.RIGHT_PARENTHESIS) {
            this.tokensValid = false;
            let getJsonCallback = json => {
                toast({
                    color: 'danger',
                    title: json["api-token-parse-0001"],
                    content: json["api-token-parse-0002"],
                });
            };
            getMultiLang({ moduleId: "api_token_parse_model", callback: getJsonCallback });
            return node;
        } else {
            this.tokensValid = false;
            let getJsonCallback = json => {
                toast({
                    color: 'danger',
                    title: json["api-token-parse-0001"],
                    content: json["api-token-parse-0002"],
                });
            };
            getMultiLang({ moduleId: "api_token_parse_model", callback: getJsonCallback });
            return node;
        }
        return node;
    }

    transToString() {
        let arrToken = this.arrToken;
        let str = arrToken.map(token => token.text);
        console.log(str.join(' '));
    }

    transToReadability() {
        let arrToken = this.arrToken;
        let htm = arrToken.map((token, idx) => `<span class="expr-item" id="item_${idx}">${token.text}</span>`);
        return htm;
    }

    executeAst(dataSet, node, operatorFuncs = {}) {
        if (!node) {
            return false;
        }
        let { type, tokenType, children = [], ...rest } = node;
        let calculateFunc = DefaultOperators[tokenType];
        let operatorFunc = operatorFuncs[tokenType];
        if (tokenType === TokenType.INDEX || tokenType === TokenType.FIELD) {
            node.tValue = !operatorFunc
                ? calculateFunc(node, dataSet)
                : operatorFunc(node, dataSet);
        } else {
            let lh = this.executeAst(dataSet, children[0], operatorFuncs);
            let rh = this.executeAst(dataSet, children[1], operatorFuncs);

            let lv = get(lh, ['tValue']);
            let rv = get(rh, ['tValue']);
            if (!operatorFunc && lh.itemType === 'number') {
                lv = lv && Number(lv);
                rv = rv && Number(rv);
            }

            node.tValue = !operatorFunc
                ? calculateFunc(lv, rv)
                : operatorFunc(node, dataSet, lh, rh);
        }
        return node;
    }

    execAST(demoValue) {

        const recursion = ast => {
            let { type, text, children } = ast;
            if (type === 'logical') {
                if (text === TokenType.OR) {
                    return recursion(children[0]) || recursion(children[1]);
                } else if (text === TokenType.AND) {
                    return recursion(children[0]) && recursion(children[1]);
                } else if (text === TokenType.GT) {
                    return recursion(children[0]) > recursion(children[1]);
                } else if (text === TokenType.GE) {
                    return recursion(children[0]) >= recursion(children[1]);
                } else if (text === TokenType.LT) {
                    return recursion(children[0]) < recursion(children[1]);
                } else if (text === TokenType.LE) {
                    return recursion(children[0]) <= recursion(children[1]);
                } else if (text === TokenType.EQUAL) {
                    return recursion(children[0]) === recursion(children[1]);
                } else if (text === TokenType.PLUS) {
                    return recursion(children[0]) + recursion(children[1]);
                } else if (text === TokenType.MINUS) {
                    return recursion(children[0]) - recursion(children[1]);
                } else if (text === TokenType.MULTIPLY) {
                    return recursion(children[0]) * recursion(children[1]);
                } else if (text === TokenType.DIVIDE) {
                    return recursion(children[0]) / recursion(children[1]);
                }
            } else {
                let arr = text.split('.');
                if (arr.length === 2) {
                    let [areacode, itemcode] = arr;
                    return demoValue[areacode][itemcode];
                } else {
                    return text;
                }

            }
        };

        return recursion(this.nodeTree);
    }

    /**
     *
     * @param {Any} dataset 数据源
     * @param {Object} operatorFuncs 自定义处理方法集{[TokenType.OR]: (node, lh, rh, dataSet) => {}, ...}
     * @returns
     */
    getCalculateResult(dataset, operatorFuncs = {}) {
        let result = this.executeAst(dataset, this.nodeTree, operatorFuncs);
        return result.tValue;
    }
}
export { TokenParseModel };
